import { useVideoStore } from '../VideoSetting'
import * as Sentry from '@sentry/react'

type ErrorName =
  | 'AbortError'
  | 'NotAllowedError'
  | 'NotFoundError'
  | 'NotReadableError'
  | 'OverconstrainedError'
  | 'SecurityError'
  | 'TypeError'
  | ''

export const setDisplayMedia = async () => {
  let stream: any = null

  try {
    stream = await navigator.mediaDevices.getDisplayMedia()
  } catch (err) {
    Sentry.captureException(err)
    console.error('setDisplayMedia error: ' + err)
  }

  return stream
}

export const removeDisplayMedia = async (stream: any) => {
  if (stream) {
    stream.getTracks().forEach(track => {
      if (track.readyState == 'live') {
        track.stop()
      }
    })
  }
}

export const muteTrack = async (stream: any, kind: string) => {
  stream.getTracks().forEach(track => {
    if (track.readyState == 'live' && track.kind == kind) {
      track.enabled = !track.enabled
      console.log('=====', track)
    }
  })
}

export const getConnectedDevices = async type => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    return devices.filter(device => device.kind === type)
  } catch (e) {
    return []
  }
}

export const setUserMedia = async (audioId = null, videoId = null) => {
  const setWebcamAccess = useVideoStore.getState().setWebcamAccess
  const setAudioAccess = useVideoStore.getState().setAudioAccess
  const setVideoWidth = useVideoStore.getState().setVideoWidth
  const setVideoHeight = useVideoStore.getState().setVideoHeight
  const setStatus = useVideoStore.getState().setStatus
  const setErrorMedia = useVideoStore.getState().setErrorMedia
  useVideoStore.getState()

  let stream: any = null
  let audioAccess: any = null
  let videoAccess: any = null

  audioAccess = await getConnectedDevices('audioinput')
  videoAccess = await getConnectedDevices('videoinput')

  try {
    if (audioAccess.length || videoAccess.length) {
      stream = await navigator.mediaDevices
        .getUserMedia({
          audio: audioAccess.length
            ? audioId
              ? {
                  deviceId: { exact: audioId },
                }
              : true
            : false,
          video: videoAccess.length
            ? videoId
              ? {
                  deviceId: { exact: videoId },
                }
              : true
            : false,
        })
        .catch((e: DOMException) => {
          setErrorMedia(e.name as ErrorName)
          setStatus('fail')
        })
    } else {
      stream = new MediaStream()
      setStatus('success')
    }

    if (stream) {
      setStatus('success')
      let videoTracks = stream.getVideoTracks()
      let audioTracks = stream.getAudioTracks()

      if (!videoTracks || videoTracks.length === 0) {
        console.log('---- No webcam')
        setWebcamAccess(false)
      } else {
        setWebcamAccess(true)

        const height = stream.getVideoTracks()[0].getSettings().height
        const width = stream.getVideoTracks()[0].getSettings().width
        setVideoWidth(width)
        setVideoHeight(height)
      }

      if (!audioTracks || audioTracks.length === 0) {
        console.log('---- No audio')
        setAudioAccess(false)
      } else {
        setAudioAccess(true)
      }
    }
  } catch (err) {
    Sentry.captureException(err)
    console.error('setUserMedia error: ' + err)
    setWebcamAccess(false)
    setAudioAccess(false)

    return new MediaStream()
  }

  return stream
}
